import {
  Input,
  InputProps,
  styled,
} from '@mui/material'

export const StyledInput = styled((props: InputProps) => <Input {...props} />)(() => ({
  '&': {
    padding: '9px 8px',
    borderRadius: '8px',
    border: '1px solid #9CA3AE',
    backgroundColor: '#2E3846',
    fontSize: '14px',
    lineHeight: '20px',
  },
  '& .MuiInput-input': {
    padding: '0 0 0 8px',
    color: '#9CA3AE',
    height: '20px',
    '::placeholder': {
      color: '#9CA3AE',
    },
  },
}))
